
  var _styles = {
  "hotel-dynamic-poi-list-top-area-normal": {
    "width": "4.56rem",
    "height": "3.41333rem"
  },
  "hotel-dynamic-poi-list-card-container-normal": {
    "width": "4.56rem",
    "height": "6.92rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "hotel-dynamic-poi-list-top-area-small": {
    "width": "4.18667rem",
    "height": "3.13333rem"
  },
  "hotel-dynamic-poi-list-card-container-small": {
    "width": "4.18667rem",
    "height": "6.53333rem",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "hotel-dynamic-poi-list-book-info-container": {
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "0.10667rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "hotel-dynamic-poi-list-book-info": {
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "marginLeft": "0.08rem"
  },
  "hotel-dynamic-poi-list-head-icon": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "paddingTop": "0.10667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.10667rem",
    "paddingLeft": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "hotel-dynamic-poi-list-head-icon-image-container": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "2rem",
    "height": "0.16rem",
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "hotel-dynamic-poi-list-head-icon-image": {
    "borderTopLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem"
  },
  "hotel-dynamic-poi-list-head-icon-text": {
    "fontSize": "0.32rem"
  },
  "hotel-dynamic-poi-list-poi-name": {
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "hotel-dynamic-poi-list-score-rating-user-review-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "hotel-dynamic-poi-list-score": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(6,68,155)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "hotel-dynamic-poi-list-rating": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(0,64,153)",
    "whiteSpace": "nowrap",
    "marginRight": "0.02667rem"
  },
  "hotel-dynamic-poi-list-user-review": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "whiteSpace": "nowrap",
    "color": "rgb(0,64,153)"
  },
  "hotel-dynamic-poi-list-discount-content": {
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "marginRight": "0.08rem",
    "textAlign": "left"
  },
  "hotel-dynamic-poi-list-sales-count-content": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "hotel-dynamic-poi-list-sales-count-container": {
    "background": "#fff1ec",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "hotel-dynamic-poi-list-discount-container": {
    "background": "#ff4700",
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.05333rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "hotel-dynamic-poi-list-small-tag-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start"
  },
  "hotel-dynamic-poi-list-prev": {
    "fontWeight": "500",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "hotel-dynamic-poi-list-price": {
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0,
    "lineHeight": "0.58667rem",
    "fontFamily": "MTNewDigitalDisplay-Bold"
  },
  "hotel-dynamic-poi-list-behind": {
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "letterSpacing": 0
  },
  "hotel-dynamic-poi-list-buy-button-text": {
    "fontWeight": "600",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem"
  },
  "hotel-dynamic-poi-list-sell-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "hotel-dynamic-poi-list-origin-price": {
    "textDecoration": "line-through",
    "fontWeight": "400",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.34667rem"
  },
  "hotel-dynamic-poi-list-price-area": {
    "position": "relative"
  },
  "hotel-dynamic-poi-list-price-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "hotel-dynamic-poi-list-buy-button-wrap": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgb(255,119,0)",
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(0,0,0)",
    "borderRadius": "30px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.32rem"
  },
  "hotel-dynamic-poi-list-bottom-area": {
    "width": "100%",
    "height": "3.50667rem",
    "paddingTop": "0.10667rem",
    "paddingRight": "0.24rem",
    "paddingBottom": "0.32rem",
    "paddingLeft": "0.24rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "hotel-dynamic-poi-list-position-info": {
    "fontSize": "0.24rem",
    "fontFamily": "PingFang SC",
    "color": "rgb(119,119,119)",
    "textDecoration": "none",
    "marginBottom": "0.02667rem",
    "maxWidth": "100%"
  }
};



  module.exports = _styles;
  